import { LOGIN_API } from "../../../components/common/api";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  loginFailure,
  loginStart,
  loginSuccess,
} from "../../reducer/LoginReducer/LoginReducer";

function generateDeviceId() {
  return `${navigator.userAgent}-${new Date().getTime()}`;
}

function getDeviceType() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android/i.test(userAgent)) {
    return "Android";
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }
  return "Web";
}
export const login = (email, password) => async (dispatch) => {
  try {
    dispatch(loginStart());
    const device_id = generateDeviceId();

    const device_type = getDeviceType();
    const response = await axiosInstance.post(`${LOGIN_API}`, {
      email,
      password,
      device_id: device_id,
      device_token: "3455788",
      device_type: device_type,
    });
    console.log("response", response);

    const token = response.data?.result?.token;
    if (token) {
      dispatch(
        loginSuccess({
          token: token,
          user: response.data.result,
        })
      );
    } else {
      throw new Error("Token not found in response");
    }
  } catch (error) {
    const message = error.response?.data?.message || "Login failed";
    let customMessage = "";
    if (message.toLowerCase().includes("incorrect email")) {
      customMessage = "Incorrect email";
    } else if (message.toLowerCase().includes("incorrect password")) {
      customMessage = "Incorrect password";
    } else {
      customMessage = "Incorrect email and password";
    }

    dispatch(loginFailure(customMessage));
  }
};
